export class AddPanda {
    public static type = '[Zoo] AddPanda';
}
export class AddBear {
    public static type = '[Zoo] AddBear';
}
export class AddPandaAndBear {
    public static type = '[Zoo] AddPandaAndBear';
}
